import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RotateCcw, X } from "lucide-react";

const RevertCancelModal = ({
  open,
  onClose,
  onConfirm,
  policyId,
  customerName,
  isSubmitting = false,
}) => {
  const displayId =
    policyId && policyId !== "N/A" && policyId.length > 20
      ? `${policyId.substring(0, 20)}...`
      : policyId;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="flex fixed inset-0 z-50 justify-center items-center p-4"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 backdrop-blur-sm bg-black/40"
            onClick={isSubmitting ? undefined : onClose}
          />
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.98 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="overflow-hidden relative z-10 w-full max-w-md bg-white rounded-2xl ring-1 ring-gray-100 shadow-2xl"
            role="dialog"
            aria-modal="true"
          >
            <div className="absolute inset-x-0 top-0 h-1 bg-emerald-600" />
            <div className="p-6">
              <div className="flex gap-3 items-start">
                <div className="grid place-items-center flex-shrink-0 w-11 h-11 text-emerald-700 bg-emerald-50 rounded-xl">
                  <RotateCcw size={22} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-gray-900">
                    Revert cancellation?
                  </h3>
                  <p className="mt-1 text-sm text-gray-600">
                    This keeps policy{" "}
                    <span className="font-mono font-semibold text-gray-900" title={policyId}>
                      {displayId || "—"}
                    </span>
                    {customerName && customerName !== "Unknown" ? (
                      <>
                        {" "}
                        for <span className="font-semibold text-gray-900">{customerName}</span>
                      </>
                    ) : null}{" "}
                    active and clears the cancel request.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={onClose}
                  disabled={isSubmitting}
                  className="grid place-items-center flex-shrink-0 w-9 h-9 text-gray-500 rounded-lg hover:text-gray-700 hover:bg-gray-50 disabled:opacity-50"
                  aria-label="Close"
                >
                  <X size={18} />
                </button>
              </div>
              <div className="flex gap-3 justify-end mt-6">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={isSubmitting}
                  className="px-4 py-2 text-sm font-semibold text-gray-700 rounded-lg ring-1 ring-gray-200 hover:bg-gray-50 disabled:opacity-50"
                >
                  Keep pending
                </button>
                <button
                  type="button"
                  onClick={onConfirm}
                  disabled={isSubmitting}
                  className="px-4 py-2 text-sm font-semibold text-white bg-emerald-700 rounded-lg hover:bg-emerald-800 disabled:opacity-60"
                >
                  {isSubmitting ? "Reverting…" : "Revert cancellation"}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RevertCancelModal;
